import type { FeatureLike } from "ol/Feature";
import type { MapBrowserEvent } from "ol";
import { CensusMapLocation } from "./CensusMapLocation";
import { Coordinate } from "ol/coordinate";
import { MapClick } from "../../../../reactOL/interactions";
import RenderFeature, { toGeometry } from "ol/render/Feature";

interface GbCensusSelectLocationProps {
  active: boolean;
  onSelectLocation?: (
    location: CensusMapLocation,
    coordinate: Coordinate,
  ) => void;
}

const GbCensusSelectLocation = ({
  active,
  onSelectLocation,
}: GbCensusSelectLocationProps) => {
  const onClick = (features: FeatureLike[], e: MapBrowserEvent<any>) => {
    if (features.length > 0) {
      const feature = features[0];
      const locationId = feature.get("id");
      const outputAreaId = feature.getProperties().outputArea;

      if (onSelectLocation && locationId && outputAreaId) {
        const geometry =
          feature instanceof RenderFeature ?
            toGeometry(feature)
          : (feature.getGeometry() ?? undefined);

        const location: CensusMapLocation = {
          id: locationId,
          outputAreaId: outputAreaId,
          geometry,
        };
        onSelectLocation(location, e.coordinate);
      }
    }
  };

  return <MapClick active={active} onClick={onClick} />;
};

export default GbCensusSelectLocation;
